import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getTypesSig, getAgrupador, removeAgrupador } from '../../actions';
import moment from 'moment';
import ModalConfirm from '../Modais/ModalConfirm';
import { Trash2 } from 'react-feather';
import { ToastContainer, toast } from 'react-toastify';

class Agrupador extends Component {
    state = { agrupador: '' }

    componentDidMount(){
        this.props.getAgrupador()        
    }

    remove = () => {
        const { agrupador } = this.state
        this.props.removeAgrupador(agrupador, res => {
            document.querySelector('#modalConfirm .close').click()
            if(res){                
                this.props.getAgrupador()
            }
        })
    }

    render(){
        console.log(this.props)
        const { load_agrupador, tags } = this.props.documentos
        return(
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center'}}>
                <table className="table table-bordered" id="tableAgrupador">
                    <thead className="thead-dark">
                        <tr>
                            <th scope="col">Titulo</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Data de criação</th>
                            <th scope="col">Última atualização</th>
                            <th scope="col">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tags && tags.map( (tag) => {
                                const { titulo, descricao, created_at, updated_at } = tag
                                return(
                                    <tr id={descricao}>
                                        <td>{titulo}</td>
                                        <td>{descricao}</td>
                                        <td>{moment(created_at).format('DD/MM/YYYY H:mm:ss')}</td>
                                        <td>{moment(updated_at).format('DD/MM/YYYY H:mm:ss')}</td>
                                        <td onClick={() => this.setState({ agrupador: descricao })}>
                                            <Trash2 style={styles.feather} data-toggle="modal" data-target="#modalConfirm" />
                                        </td>
                                    </tr>
                                )
                            })                                
                        }
                    </tbody>
                </table>
                {load_agrupador && <div className="spinner-border" role="status" style={{margin:'5%'}}>
                                <span className="sr-only">Loading...</span>
                            </div>}

                <ModalConfirm load={load_agrupador} title={'Atenção!'} accept={this.remove} text={'Deseja realmente excluir este agrupador?'} />
                <ToastContainer autoClose={3000} position={toast.POSITION.BOTTOM_CENTER} draggable={false}/>
            </div>
        )
    }
}

const styles = {
    feather: {
        width: '16px',
        height: '16px',
        verticalAlign: 'text-bottom',
        marginRight:6,
        cursor: 'pointer'
    }
}

const mapStateToProps = ({ auth, signatario, documentos }) => {
    return {
        auth, signatario, documentos
    }
}

export default connect(mapStateToProps, {
    getAgrupador, removeAgrupador
})(Agrupador);